import './Slider.styles.scss';

export default function Slider(): JSX.Element {
	return <div>Slider</div>;
}
